import * as d3 from './d3';
// import { intcomma } from 'journalize';

class PowerBalance {
  constructor(type) {
    this.defaultProps = {
      congressType: type,
    };
  }
  selection(selector) {
    if (!selector) return this._selection;
    this._selection = d3.select(selector);
    return this;
  }
  data(obj) {
    if (!obj) return this._data;
    this._data = obj;
    return this;
  }
  props(obj) {
    if (!obj) return this._props || this.defaultProps;
    this._props = { ...this.defaultProps, ...this._props, ...obj };
    return this;
  }
  render() {
    const { data } = this.data();
    const graphic = this.selection();
    const { congressType } = this.props();
    const total = congressType == 'house' ? 435 : 100;

    const es = d3.select('.elections-2020').attr('data-es') === 'true';

    const bar = graphic.appendSelect('div', 'graphic__bar');

    bar.appendSelect('div', 'bar__finish-line');

    bar
      .selectAll('div.bar__party')
      .data(data.trendtable.party)
      .join('div')
      .attr('class', 'bar__party')
      .attr('data-party', d => d.title)
      .style('width', d => `${(+d.trend[0].Won / total) * 100}%`)
      .appendSelect('span', 'party__count')
      .text(d => `${d.trend[0].Won > 0 ? '+' : ''}${d.trend[0].Won}`);

    if (congressType == 'senate') {
      bar
        .selectAll('div.bar__party-holdover')
        .data(data.trendtable.party)
        .join('div')
        .attr('class', 'bar__party-holdover')
        .attr('data-party', d => d.title)
        .style('width', d => `${(d.trend[2].Holdovers / total) * 100}%`)
        .appendSelect('span', 'holdover__count');
      // .text(d => `${d.trend[2].Holdovers}`);

      // Adds total to sides
      graphic
        .selectAll('.senate__total')
        .data(data.trendtable.party.slice(0,2))
        .join('div')
        .text(function(d) {
          if (d.title == 'Dem') {
          return +d.trend[0]["Won"] + +d.trend[2]["Holdovers"] + 2
          } else {
            return +d.trend[0]["Won"] + +d.trend[2]["Holdovers"]
          }
        })
    }

    bar
      .appendSelect('div', 'bar__legend')
      .datum(data.trendtable.party.find(d => d.title == 'GOP'))
      .style('width', d => `${(d.trend[0].Won / total) * 100}%`)
      .appendSelect('span')
      .text(es ? 'Escaños ganados' : 'Seats won');

    const remaining = graphic.appendSelect('div', 'graphic__remaining');

    const seatsFilled = data.trendtable.party
      .map(d => d.trend[0].Won)
      .reduce((acc, cur) => +acc + +cur);

    let seatsLeft;
    if (congressType == 'house') {
      seatsLeft = total - seatsFilled;
    } else {
      seatsLeft = 35 - seatsFilled;
    }

    bar
      .appendSelect('div', 'bar__party-remain')
      .datum(seatsLeft)
      .style('width', d => `${(d / total) * 100}%`)
      .attr('data-party', 'Remain');

    remaining
      .appendSelect('div', 'remaining__text')
      .text(es ? 'Escaños restantes:' : 'Seats remaining:');

    remaining
      .appendSelect('div', 'remaining__value')
      .appendSelect('span')
      .text(seatsLeft);
  }
}

export default PowerBalance;
